import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getPanNumberApi,
  createReactivateDetailApi,
  validateReactivateReqApi,
} from "designs/v1/pages/ModifyKyc/services";
import { validateOnNumber, validateOnPaste } from "utils";
import moment from "moment";

const ValidatePan = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  setActiveUserDetail,
}) => {
  const currentDate = new Date();
  const [showModal, setShowModal] = useState({
    show: false,
    data: "",
  });
  const [panNumber, setPanNumber] = useState({
    data: [],
    loading: true,
  });
  const [kycDetails, setKycdetails] = useState({});
  const user = JSON.parse(sessionStorage.getItem("user") || {});
  const [initialValues, setInitialValues] = useState({
    pan: user?.pan ?? "",
  });
  const validationSchema = Yup.object().shape({
    pan: Yup.string()
      .min(10)
      .required("PAN number is required.")
      .matches("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$", "Invalid PAN number"),
  });

  const loadRequestTypes = async () => {
    try {
      const resp = await getPanNumberApi();
      const data = resp.data?.data?.pan_number || [];
      if (data.length === 1) {
        setInitialValues((prev) => ({ ...prev, pan: data[0] }));
      }
      setPanNumber({ data, loading: false });
      setKycdetails(resp.data?.data?.user_details || {});
    } catch (error) {
      console.error("err", error);
      setPanNumber({ data: [], loading: false });
    }
  };

  useEffect(() => {
    loadRequestTypes();
  }, []);

  const verifyPanNumber = async (value) => {
    setIsLoading(true);
    // const payload = {
    //   pan: value.pan,
    // };
    // try {
    //   const panResp = await getPanNumberApi(payload);
    //   const { pan_number } = panResp.data.data || [];
    //   setIsLoading(false);
    //   if (!pan_number.includes(value.pan)) {
    //     return toast.error("Error: Invalid PAN Number");
    //   }
    const data = {
      pan: value.pan,
      account_reactivation: true,
    };
    handleReactivate(data);
    // setShowModal(() => ({ data: payload.pan, show: true }));
    // } catch (error) {
    //   setIsLoading(false);
    //   const { data } = error.response || {};
    //   toast.error(data.message || "Internal server error!");
    // }
  };

  const handleReactivate = async (data) => {
    setIsLoading(true);
    try {
      const payload = {
        request_type: "Reactivation",
        pan_no: data.pan,
        active_mobile_no: kycDetails.active_mobile_no,
        active_kyc: kycDetails.active_kyc,
        client: kycDetails.client,
      };
      const prevReq = await validateReactivateReqApi(payload);
      setIsLoading(false);
      if (
        prevReq.data?.data?.status === "Submitted" &&
        prevReq.data?.data?.date
      ) {
        const DAYS = 7;
        const differenceInDays = moment(currentDate)
          .startOf("day")
          .diff(
            moment(new Date(prevReq.data.data?.date)).startOf("day"),
            "days"
          );
        if (differenceInDays <= DAYS) {
          return toast.error(
            `Your previous reactivation request already exists. Please create a new request on
            ${moment(new Date(prevReq.data.data?.date))
              .add(DAYS + 1, "days")
              .format("DD MMM YYYY")}.`
          );
        }
      }
      try {
        const resp = await createReactivateDetailApi(data);
        setActiveUserDetail({
          request_number: resp?.data?.data?.request_number,
          ucc_code: resp?.data?.data?.ucc_number,
          demat_account_no: resp?.data?.data?.demat_account_no,
        });
        setStep("DematUccForm");
      } catch (error) {
        setIsLoading(false);
        const { data } = error.response || {};
        toast.error(data.message || "Internal server error!");
      }
    } catch (error) {
      setIsLoading(false);
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
    }
  };

  return (
    <div>
      <Title title="PAN Details" />
      <div className="col-md-9 mt-3">
        <div className="ml-2">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={verifyPanNumber}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <div className="form-group my-2">
                  <label className="py-1">PAN Number</label>
                  <Field
                    as="select"
                    name="pan"
                    type="text"
                    className="form-select"
                    onChange={({ target }) =>
                      setFieldValue("pan", target.value.toUpperCase())
                    }
                  >
                    <option
                      value={""}
                      disabled
                    >
                      -- Select PAN Number --
                    </option>
                    {panNumber.data.length > 0 ? (
                      panNumber.data.map((item) => {
                        return (
                          <option
                            key={item}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })
                    ) : (
                      <option
                        value={""}
                        disabled={panNumber.loading}
                      >
                        {panNumber.loading ? "Loading..." : "No Record Found"}
                      </option>
                    )}
                  </Field>
                  {/* <Field
                    type="text"
                    name="pan"
                    placeholder="Pan Number"
                    className="form-control"
                    onChange={({ target }) =>
                      setFieldValue("pan", target.value.toUpperCase())
                    }
                    maxLength="10"
                  /> */}
                  <ErrorMessage
                    name="pan"
                    className="inline-errormsg my-1"
                    component="div"
                  />
                </div>
                <div className="d-flex form-group my-4">
                  <div className="mx-2">
                    <Button
                      type="button"
                      title="Back"
                      handleClick={() => setStageScreen("")}
                      loading={isLoading}
                    />
                  </div>
                  <div className="mx-2">
                    <Button
                      title="Submit"
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {/* <Modal show={showModal.show}>
        <Modal.Header>
          <Modal.Title>Reactivate</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Do you want to reactivate the account?</h6>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            title="No"
            handleClick={() => setStageScreen("")}
          />
          <Button
            type="button"
            title="Yes"
            handleClick={() => handleReactivate()}
          />
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default ValidatePan;
